export default __webpack_public_path__ + "static/board2-3e84d685c4f2f1ba29325bdaff5c9371.jpg";